export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de lotes"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos del lote"])},
          "title_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaques"])},
          "percents": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Porcentajes exportable - descarte"])}
        }
      }
    }
  })
}